<script setup lang="ts">
  // Table content
  const formatDirectives = [
    { directive: '%Y', meaning: 'Year with century', example: '2025' },
    { directive: '%y', meaning: 'Year without century', example: '25' },
    { directive: '%m', meaning: 'Month as zero-padded number', example: '01, 12' },
    { directive: '%b', meaning: 'Abbreviated month name', example: 'Jan, Feb' },
    { directive: '%B', meaning: 'Full month name', example: 'January, February' },
    { directive: '%d', meaning: 'Day of month (zero-padded)', example: '01, 31' },
    { directive: '%H', meaning: 'Hour (24-hour, zero-padded)', example: '00, 23' },
    { directive: '%I', meaning: 'Hour (12-hour, zero-padded)', example: '01, 12' },
    { directive: '%p', meaning: 'AM/PM', example: 'AM, PM' },
    { directive: '%M', meaning: 'Minute (zero-padded)', example: '00, 59' },
    { directive: '%S', meaning: 'Second (zero-padded)', example: '00, 59' },
    { directive: '%a', meaning: 'Abbreviated weekday name', example: 'Mon, Tue' },
    { directive: '%A', meaning: 'Full weekday name', example: 'Monday, Tuesday' },
    { directive: '%w', meaning: 'Weekday as number', example: '0 (Sun) - 6' },
    { directive: '%j', meaning: 'Day of year (zero-padded)', example: '001, 366' },
    { directive: '%U', meaning: 'Week number (Sun as first)', example: '00, 53' },
    { directive: '%W', meaning: 'Week number (Mon as first)', example: '00, 53' }
  ]
</script>
<template>
  <div style="max-height: 550px; overflow-y: auto">
    <table class="popover-table">
      <thead>
        <tr>
          <th>Directive</th>
          <th>Meaning</th>
          <th>Example</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in formatDirectives" :key="row.directive">
          <td>
            <code>{{ row.directive }}</code>
          </td>
          <td>{{ row.meaning }}</td>
          <td>
            <code>{{ row.example }}</code>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
  .popover-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
  }
  .popover-table th,
  .popover-table td {
    border: 1px solid #ddd;
    padding: 6px 10px;
    text-align: left;
  }
  .popover-table th {
    background-color: #f5f5f5;
    font-weight: 600;
  }
  code {
    background-color: #f0f0f0;
    padding: 2px 4px;
    border-radius: 4px;
  }
</style>
